/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.VendorDropdownFilter = (function() {

    /**
     * Namespace VendorDropdownFilter.
     * @exports VendorDropdownFilter
     * @namespace
     */
    var VendorDropdownFilter = {};

    VendorDropdownFilter.VendorDropdownFilterModel = (function() {

        /**
         * Properties of a VendorDropdownFilterModel.
         * @memberof VendorDropdownFilter
         * @interface IVendorDropdownFilterModel
         * @property {string|null} [name] VendorDropdownFilterModel name
         * @property {number|null} [pageIndex] VendorDropdownFilterModel pageIndex
         * @property {number|null} [pageSize] VendorDropdownFilterModel pageSize
         */

        /**
         * Constructs a new VendorDropdownFilterModel.
         * @memberof VendorDropdownFilter
         * @classdesc Represents a VendorDropdownFilterModel.
         * @implements IVendorDropdownFilterModel
         * @constructor
         * @param {VendorDropdownFilter.IVendorDropdownFilterModel=} [p] Properties to set
         */
        function VendorDropdownFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * VendorDropdownFilterModel name.
         * @member {string|null|undefined} name
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @instance
         */
        VendorDropdownFilterModel.prototype.name = null;

        /**
         * VendorDropdownFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @instance
         */
        VendorDropdownFilterModel.prototype.pageIndex = null;

        /**
         * VendorDropdownFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @instance
         */
        VendorDropdownFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * VendorDropdownFilterModel _name.
         * @member {"name"|undefined} _name
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @instance
         */
        Object.defineProperty(VendorDropdownFilterModel.prototype, "_name", {
            get: $util.oneOfGetter($oneOfFields = ["name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorDropdownFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @instance
         */
        Object.defineProperty(VendorDropdownFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorDropdownFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @instance
         */
        Object.defineProperty(VendorDropdownFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified VendorDropdownFilterModel message. Does not implicitly {@link VendorDropdownFilter.VendorDropdownFilterModel.verify|verify} messages.
         * @function encode
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @static
         * @param {VendorDropdownFilter.IVendorDropdownFilterModel} m VendorDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VendorDropdownFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(16).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(24).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified VendorDropdownFilterModel message, length delimited. Does not implicitly {@link VendorDropdownFilter.VendorDropdownFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @static
         * @param {VendorDropdownFilter.IVendorDropdownFilterModel} message VendorDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VendorDropdownFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VendorDropdownFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {VendorDropdownFilter.VendorDropdownFilterModel} VendorDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VendorDropdownFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.VendorDropdownFilter.VendorDropdownFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.pageIndex = r.int32();
                    break;
                case 3:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a VendorDropdownFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof VendorDropdownFilter.VendorDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {VendorDropdownFilter.VendorDropdownFilterModel} VendorDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VendorDropdownFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return VendorDropdownFilterModel;
    })();

    return VendorDropdownFilter;
})();

module.exports = $root;
